<template>
  <div class="home">
    <page-content>
      <div class="row">
        <div class="offset-md-2 col-md-8">
          <ntm-block style="min-height: 400px">
            <div class="d-flex justify-content-between mb-4">
                <multiselect
                  class="w-auto"
                  style="min-width: 250px"
                  :multiple="false"
                  :placeholder="$tc('venue.name', 1)"
                  :custom-label="(option) => option.name"
                  v-model="selectedVenue"
                  :options="venues">

                </multiselect>
            </div>
            <le-loading v-if="isLoading"></le-loading>
            <div v-else>
              <table v-if="model.games.length" class="table table-bordered table-striped table-vcenter">
                <thead>
                <tr>
                  <th></th>
                  <th>{{ $t('time') }}</th>
                  <th>{{$tc('game.name', 1)}}</th>
                  <th>{{$tc('league.name', 1)}}</th>
                  <th v-if="!selectedVenue?.uuid">{{$tc('venue.name', 1)}}</th>
                </tr>
                </thead>
                <tbody>
                <tr v-for="game in model.games" :key="game.uuid" :class="gameStatusColor(game.status)">
                  <td style="min-width: 130px">
                    <div>
                      <button class="btn btn-info btn-sm mr-2"
                              @click="enterTheGame(game)" :disabled="!game.teamA && !game.teamB"><i class="fa fa fa-sign-in"></i></button> <span class="no-wrap">{{formattedGameCode(game.code)}}</span>
                    </div>
                  </td>
                  <td>{{ $gameTime(game.time, 'dayWithTime') }}</td>
                  <td><strong>{{ game.teamA?.name ?? '?' }}</strong> :
                    <strong>{{ game.teamB?.name ?? '?' }}</strong>
                  </td>
                  <td>{{ game.schedule.name }}</td>
                  <td v-if="!selectedVenue?.uuid">{{ game.venue.name }}</td>
                </tr>
                </tbody>
              </table>
              <div v-else class="text-center">
                <p>There is no scheduled games found</p>
              </div>
            </div>
          </ntm-block>
        </div>
      </div>

    </page-content>
  </div>
</template>
<script>
import GameService from '@/services/game.service'
import ApiService from '@/services/api.service'
import { gameStatusColor } from '@/lib/status'
import { redirectToGameRouteByStatus } from '@/use/useRedirectGame'
import LeLoading from '@/components/le/LeLoading.vue'
import { formattedGameCode } from '@/lib/gameCode'
import Multiselect from 'vue-multiselect'
import store from '@/store'

export default {
  components: { Multiselect, LeLoading },
  data () {
    return {
      venues: [],
      selectedVenue: null,
      isLoading: false,
      model: {
        games: []
      }
    }
  },
  mounted () {
    document.addEventListener('visibilitychange', this.fetchData)
    this.fetchData()
  },
  beforeDestroy () {
    document.removeEventListener('visibilitychange', this.fetchData)
  },
  beforeRouteEnter (to, from, next) {
    if (!store.getters.isAdminOrInternalScorekeeper) {
      return next('/')
    }
    GameService.gamesVenues().then((response) => {
      next(vm => vm.setVenues(response.data))
    }).catch(() => {
      // the venues could not be loaded: the list of games still opens (no venue filter)
      next()
    })
  },
  watch: {
    selectedVenue () {
      localStorage.setItem('selectedVenue', this.selectedVenue?.uuid)
      this.fetchData()
    }
  },
  methods: {
    formattedGameCode,
    fetchData () {
      this.isLoading = true
      GameService.index(this.selectedVenue?.uuid).then((response) => {
        this.setData(response.data)
      }).catch(() => {
        // the list stays as it is: the internal scorekeeper has no code page to go to
      }).finally(() => {
        this.isLoading = false
      })
    },
    enterTheGame (game) {
      ApiService.setGameCode(game.code)
      GameService.status().then((res) => {
        this.$router.push(redirectToGameRouteByStatus(this.$route.params.clientId, game.code, res.data))
      }).catch((error) => {
        this.errorCode = error.response?.status
      })
    },
    gameStatusColor,
    setData (data) {
      this.model = data
    },
    setVenues (data) {
      this.venues = data.venues

      this.selectedVenue = this.venues.find(venue => venue.uuid === localStorage.getItem('selectedVenue')) || null
    }
  }
}
</script>
